"use strict";

exports.__esModule = true;
var _AsyncBaseComponent = require("./AsyncBaseComponent");
Object.keys(_AsyncBaseComponent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AsyncBaseComponent[key]) return;
  exports[key] = _AsyncBaseComponent[key];
});